import axios from 'axios';
import toast from 'react-hot-toast';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});


apiClient.interceptors.request.use(
  (config) => {
   
    const token = localStorage.getItem('core-token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


apiClient.interceptors.response.use(
  (response) => response,
  (error) => {

    const message = error.response?.data?.message || 'An unexpected error occurred.';
    
    
    if (error.response?.status !== 409) {
      toast.error(message);
    }

    return Promise.reject(error);
  }
);

export default apiClient;